export default {
  title: 'Proceed to Checkout',
  emptyCartTitle: 'Your cart is empty!',
  emptyCartSub: "You haven't added any lovely items to your cart yet.",
  backToShop: 'Browse Shop & Products',
  unitPrice: 'Unit Price',
  quantity: 'Quantity',
  itemTotal: 'Total',
  summaryTitle: 'Order Summary',
  subtotal: 'Items Subtotal',
  tax: 'V.A.T Tax',
  shippingCost: 'Shipping Cost',
  freeShipping: 'Free',
  totalDiscount: 'Total Discount',
  discount: 'Discount',

  product: 'Product',
  discountPaymentMethod: 'Payment Method Discount',

  payableAmount: 'Total Payable',
  toman: 'Toman',
  proceedToCheckout: 'Proceed to Checkout',
  clearCart: 'Clear Cart',
  stockLimit: 'Maximum available stock reached',
  urls: {
    Product: '/product',
    Shop: '/products',
    Checkout: '/checkout',
    Shipping:"/en/cart/shipping"
  }
}
